<template>
<div class="chapter">
<div class="inner_page">
<p class="dedicenter"><a id="pV"></a>To my aunt, Elizabeth (Betty) MacDonald (1930–2011), <br/>for her inspiration and encouragement</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?bf3eac00